import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

// ---------------------------------------------------------------------------
// DO structuring drill-in state — DOCUMENT-SCOPED (hard requirement).
//
// AFE's drill-in atoms (afe-catalog/structuring/atoms/layout.ts:
// selectedWellIndexAtom / selectedCostWellIdAtom) are MODULE-scoped singletons:
// one shared value across every document. That forces the AFE module to clear
// the drill-in on mount and complicates the deep-link handling, and it would
// cross-contaminate state if an AFE and a DO (or two DOs) ever rendered at once.
//
// DO sidesteps the whole class of bug by keying the selected interest on the
// `documentId`. `selectedInterestIdAtom(documentId)` returns a per-document
// atom<string | null> — reading document A never sees document B's drill-in.
//
// The value is the drilled-in DOLI Salesforce Id (a STRING) or null when the
// Interest Overview is showing. Keep it a string end-to-end (SF Ids are not
// numeric PKs) — do NOT Number()-coerce it.
// ---------------------------------------------------------------------------

export const selectedInterestIdAtom = atomFamily(
  (_documentId: number | string) => atom<string | null>(null)
);

// ---------------------------------------------------------------------------
// DO Well Information drill-in (Match Review) — also DOCUMENT-SCOPED.
//
// Unlike the interest drill-in (keyed on a DOLI Salesforce Id STRING), a well is
// addressed by its INDEX into the well overview list (a `number | null`),
// exactly like AFE's `selectedWellIndexAtom` — the well :id is a numeric
// DivisionOrderTarget PK, and the shell's prev/next navigator walks the list by
// position. Keyed on `documentId` (atomFamily) so it never collides with AFE's
// module-scoped `selectedWellIndexAtom` singleton or another DO tab. null = Well
// Overview is showing.
// ---------------------------------------------------------------------------
export const selectedWellIndexAtom = atomFamily(
  (_documentId: number | string) => atom<number | null>(null)
);
